import React from "react";
import Logo from "../../assets/user/images/logo.svg";

const Term = () => {
  return (
    <div className="container-fluid" style={{ background: "#1d364e" }}>
      <div className="d-flex align-items-center justify-content-center">
        <img src={Logo} width={300} className="mt-3" alt="" />
      </div>
      <div className="p-4">
        <h3
          className="text-center"
          style={{ color: "#bfc3cb", fontWeight: "600" }}
        >
          Terms & Conditions
        </h3>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>1. Introduction</h4>
        <p>
          Please read this page carefully. It contains the terms and conditions
          (the "Terms and Conditions" or “Terms”) governing your access to and
          use of the Care-Exchange Web Sites and the Services (as each are
          defined below) provided by Care Exchange, Inc or one of its divisions
          (collectively, "Care-Exchange"). If you do not accept or if you object
          to anything in these Terms and Conditions or you do not meet or comply
          with their provisions, you may not use the Care-Exchange Web Sites or
          Services. These Terms and Conditions are effective as of April 1,
          2025.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          2. Binding Agreement
        </h4>
        <p>
          These Terms and Conditions (as they may be amended from time to time
          by Care-Exchange), together with the Privacy Policy, Subscription Plan
          Purchase Agreement, and your Advertising Contract (if applicable),
          form a binding agreement (the "Agreement") between you and
          Care-Exchange. Your access to or use of the Care-Exchange Web Sites
          and/or Services indicates your agreement and acceptance of these Terms
          and Conditions. You are agreeing to use the Sites at your own risk.
        </p>

        <p>
          <b>IMPORTANT NOTICE:</b> THIS AGREEMENT IS SUBJECT TO BINDING ARBITRATION
          AGREEMENT AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED IN SECTION
          16.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          3. Certain Definitions
        </h4>
        <p>
          <b>3.1 "Care-Exchange Materials"</b> includes any materials, methodologies,
          implementation plans or other intellectual property used during the
          provision of Services.
        </p>
        <p>
          <b>3.2 "Care-Exchange Web Site"</b> or the "Site" (collectively, the
          "Care-Exchange Websites" or the "Sites") means care-exchange.com and
          any web site under Care-Exchange's control, whether partial or
          otherwise and includes such Site's Content, Care-Exchange Materials
          and Services (as applicable in each context).
        </p>
        <p>
          <b>3.3 "Care Seeker"</b> means a User who is accessing the Site to seek care
          services for their loved ones and seeking to hire Care Providers or
          individual caregivers.{" "}
        </p>
        <p><b>3.4 "Care Provider"</b> has the same meaning as <b>“Employer”</b> </p>
        <p>
          <b>3.5 "Content"</b> means Care-Exchange's web pages, web forms, programming
          (including software code used on the Sites and in the Services,
          including (i) tools, kits, and object libraries, (ii) all third-party
          or open source code embedded therein, and (iii) any upgrades, updates,
          releases, fixes, enhancements or modifications to the foregoing),
          graphics, images, design (color combinations and page layout), text,
          information, data, resumes stored in various commercial databases
          operated and licensed by Care-Exchange (including, among others, its
          "Care Providers Directory Database," "Care Staff Directory Database,"
          "Job Matching Database" and the Client Database), data submitted via
          the Sites by Users and other content made available through the Sites
          by Care-Exchange.
        </p>
        <p>
          <b>3.6 "Document"</b> refers to any posting to a Site, whether job or resume
          or care form.
        </p>
        <p>
          <b>3.7 "Employer"</b> means a person, care provider, or any entity that is
          accessing the Site to post a job or utilizing the Services for any
          reason related to the purpose of seeking candidates for employment or
          providing care services to persons seeking care through the Site.
        </p>
        <p>
          <b>3.8 "Employer Materials"</b> includes any brochures, emails, sample job
          postings, web site content, career fair material, audio, videos,
          photographs, logos, trademarks, service marks, domain names, documents
          or other materials provided by Employer, if any, for use in connection
          with the Services.
        </p>
        <p>
          <b>3.9 "Job Seeker"</b> means a User who is accessing the Site to search for
          a job or in any other capacity except as an Employer.
        </p>
        <p>
          <b>3.10 "Services"</b> means any services provided by Care-Exchange or its
          agents described herein and specified more fully Section 4.0 and in
          the Subscription Plan Purchase Agreement.
        </p>
        <p>
          <b>3.11 "User"</b> refers to any individual, person, or entity that uses any
          aspect of the Sites.
        </p>
        <p>
          <b>3.12 "You"</b> or "you" means the person who (or the entity on behalf of
          whom you are acting) that is agreeing to these Terms and Conditions.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          4. Description of Services; Limitations; User Responsibilities
        </h4>
        <p><b>4.1 About Our Services</b></p>
        <p>
          Care-Exchange.com offers various Services to help its users find,
          coordinate, and maintain quality care. The Services we offer include,
          among others:
        </p>

        <ul>
          <li>
            We provide a platform which promotes and facilitates connections
            between persons (clients) seeking care services for their loved ones
            and care providers and caregivers.
          </li>
          <li>
            We provide a platform for individuals seeking care services (such as
            individual or shared home care, medical care, child care, senior
            care, special needs, pet care, and housekeeping services) and
            corporate care providers seeking to hire individual care providers
            (such as healthcare agencies and facilities, child centers, in-home
            care agencies, and senior living facilities) (each “Care Seekers”)
            to post jobs on the Site, and to search for, narrow, find, and
            communicate with individuals and entities who provide care services
            (“Care Providers”), and for Care Providers to post profiles on the
            Site and browse, search, and apply to jobs. We also provide
            functionality that allows Care Seekers to search for and message
            other Care Seekers to help facilitate shared care services.
          </li>
          <li>
            We provide tools and information to help Care Seekers and Care
            Providers make more informed decisions, such as (i) our Care
            Community which includes communication resources, and (ii) Care
            Budgeting and Expense Management resources.
          </li>
          <li>
            We provide a platform with free job alert and career network that
            focuses on matching employers (Care Providers) to potential
            applicants (Care Staff) through our easy-to-use job search service
            (Find Jobs).{" "}
          </li>
          <li>
            We provide a platform that allows you to post job opportunities,
            find quality employees, and hire the right person for your business
          </li>
          <li>
            We provide a directory of entities Care Providers that operate
            care-related businesses such as healthcare agencies and facilities,
            child care centers, in-home care agencies, senior living facilities,
            in-home care agencies, senior care housing companies and
            housekeepers from which users may contact or request information.
          </li>
          <li>
            We provide an online community for Users to communicate and share
            information with other Users who share a common interest or bond.
            Our platform provides an opportunity to engage with people who may
            share similar needs and experience, or who may be in the same
            industry. The platform aims to provide a safe, supportive and
            accessible environment for all care community members.
          </li>
          <li>
            We provide a platform which provides an opportunity for you to
            manage your budget for customer leads and acquisitions, and
            advertisements. It allows you to manage your expenses and how much
            you are willing to spend on leads and advertisements.{" "}
          </li>
          <li>
            We provide a platform that offers a Subscription Plan for our
            services. These services require that you pay a fee or make a
            pre-authorized payment in order to use or get the benefit of our
            services that you have chosen to meet your needs. When you choose
            and purchase a subscription plan, you agree to the Subscription Plan
            Purchase Agreement.
          </li>
          <li>
            We offer through Paypal, Inc., (“Paypal”), a third party, a service
            that facilitates the payment for Subscription Plan purchases by
            Business entities, Care Providers, Care Seekers, and any person
            using our services via credit card or debit card. These payment
            processing services are provided by Paypal and are subject to the
            Paypal Account Agreement, which includes the Paypal Terms and
            Conditions (collectively, the “Paypal Services Agreement”). By
            agreeing to these Terms, businesses and Care Providers that use the
            payment service also agree to be bound by the Paypal Services
            Agreement, as the same may be modified by Paypal from time to time.
            As a condition of Care-Exchange.com enabling payment processing
            services through Paypal, you agree to provide Care-Exchange.com
            accurate and complete information about you, and you authorize
            Care-Exchange.com to share it and transaction information related to
            your use of the payment processing services provided by Paypal.
            Care-Exchange.com assumes no liability or responsibility for any
            payments you may make through this service, and all such payments
            are non-refundable.{" "}
          </li>
          <li>
            We offer eligible Care Providers access to various benefits from
            third party service providers, including, without limitation, those
            that offer access to health insurance, and other benefits.
          </li>
        </ul>
        <p>
          Our Services continue to grow and change. Please refer to our Site for
          further information about the Services we provide.
        </p>
        <p><b>4.2 Limitations of our Services</b></p>
        <p>
          We offer Services as detailed in Section 4.1 above. However, except
          where specifically provided in these Terms and Conditions, in any
          applicable Additional Terms, or on the Site itself
        </p>
        <ul>
          <li>
            We do not employ any Care Providers and are not responsible for the
            conduct, whether online or offline, of any Care Seeker, Job Seeker,
            Care Provider, or other user of the Site or Services. Care Seekers,
            Job Seekers, and Care Providers are responsible for compliance with
            all applicable employment and other laws in connection with any
            employment relationship they establish (such as applicable
            licensing, insurance, health and safety, payroll, tax and minimum
            wage laws).
          </li>
          <li>
            Care Seeker, Job Seekers, and Care Provider content is primarily
            user generated. We do not control or vet user-generated content for
            accuracy, and we do not assume and expressly disclaim any
            responsibility for the accuracy or reliability of any information
            provided by Care Providers or Care Seekers or Job Seekers on or off
            the Site. We do not assume and expressly disclaim any liability that
            may result from the use of information provided on our Site.
          </li>
          <li>
            We do not refer or recommend Care Seekers, Job Seekers, or Care
            Providers nor do we make any representations about the suitability,
            reliability, timeliness, or accuracy of the services provided by
            Care Providers or the integrity, responsibility or actions of Care
            Seekers, Job Seekers, or Care Providers whether in public, private
            or offline interactions. Any screening of a Care Seeker, Job Seeker,
            or Care Provider and his, her or its information by
            Care-Exchange.com is limited and should not be taken as complete,
            accurate, up-to-date or conclusive of the individual’s or entity’s
            suitability as an employee or employer or care provider.
          </li>
          <li>
            We are not an employment agency, and we do not secure or procure
            employees for any Care Seekers, nor do we secure or procure
            opportunities for employment for any Care Providers or business
            entity.
          </li>
          <li>
            We do not control, monitor, supervise, or oversee the quality,
            timing, hours, pay, legality, or any other aspect of services
            delivered by Care Providers, nor do we require Care Providers to
            accept or do any jobs or deliver any services at all.
          </li>
          <li>
            We do not provide any medical, diagnostic, treatment or clinical
            service or engage in any conduct that requires a professional
            license or expertise.
          </li>
          <li>
            We may offer certain Users the opportunity to verify certain
            information such as their email address, cell phone number, or, in
            the case of child care centers, their local or state license
            information. If we indicate that certain information has been
            verified, it means that the user has complied with the process we
            have established for verifying such information. However, we do not
            guarantee, nor do we represent or warrant, that the information is
            accurate or that it belongs to the User who supplied it.{" "}
          </li>
        </ul>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          5. Intellectual Property Rights and Acceptable Use of the Sites and
          Services.
        </h4>
        <p>
          <b>5.1 General Use Rules.</b> The Sites are intended for individuals seeking
          employment and for employers or recruiters seeking candidates for
          employment. You may use the Sites only for lawful purposes within the
          stated context of Care-Exchange's intended and acceptable use of the
          Sites. Care-Exchange is the sole interpreter of the Sites' intended
          and acceptable use.
        </p>
        <p>
          <b>5.2 Care-Exchange Intellectual Property Rights.</b> The Sites, the
          Care-Exchange Materials and all right, title and interest in and to
          the Sites and Care-Exchange Materials are the sole property of
          Care-Exchange or its licensors, and are protected by United States and
          foreign copyright, trademark and other laws. Except for the limited
          licenses expressly granted to you in these Terms and Conditions,
          Care-Exchange reserves for itself and its licensors all other rights,
          title and interest. Without limitation on the foregoing, you may not
          reproduce, modify, display, sell, or distribute the Content or
          Care-Exchange Materials, or use them in any other way for public or
          commercial purpose. Notwithstanding anything to the contrary contained
          herein, this prohibition includes: (a) copying or adapting the HTML
          code used to generate web pages on the Sites; (b) using or attempting
          to use engines, manual or automated software, tools, devices, agents,
          scripts, robots or other means, devices, mechanisms or processes
          (including, but not limited to, browsers, spiders, robots, avatars or
          intelligent agents) to navigate, search, access, "scrape," "crawl," or
          "spider" any web pages or any Services provided on the Sites other
          than the search engine and search agents available from Care-Exchange
          on such Care-Exchange Sites and other than generally available third
          party web browsers (e.g., Internet Explorer, Firefox, Safari); and (c)
          aggregating, copying or duplicating in any manner any of the Content
          or information available from any of the Care-Exchange Sites, without
          the express written consent of Care-Exchange. The use of the Content
          on any other web site or in a networked computer environment for any
          purpose is strictly prohibited. The Care-Exchange Materials are not
          considered to be works for hire and you may duplicate such
          Care-Exchange Materials only for the purposes outlined in the
          Subscription Plan Purchase Agreement. "Care-Exchange," "Personified",
          the Care-Exchange design logo and certain other names or logos are
          service marks or trademarks of Care-Exchange, and all related product
          and service names, design marks and slogans are the service marks or
          trademarks of Care-Exchange. In addition, the "look" and "feel" of the
          Sites (including color combinations, button shapes, layout, design and
          all other graphical elements) are also protected by Care-Exchange's
          trademarks, service marks and copyrights. Any code that Care-Exchange
          creates to generate or display the Content or the pages making up the
          Sites is also protected by Care-Exchange's copyright. You must retain
          all copyright, trademark, service mark and other proprietary notices
          contained on the Content or Care-Exchange Materials on any authorized
          copy you make of the Content or Care-Exchange Materials. All other
          product and service marks contained on the Sites are the trademarks of
          their respective owners.
        </p>
        <p>
          <b>5.3 License to Use by Users who are Job Seekers.</b> Care-Exchange hereby
          grants you a limited, terminable, non-exclusive right to access and
          use the Sites only for your personal use seeking employment
          opportunities for yourself. This authorizes you to view and download a
          single copy of the material on the Sites solely for your personal,
          noncommercial use. You agree that you are solely responsible for the
          content of any Document you post to a Site and any consequences
          arising from such posting. Your use of the Sites is a privilege.
          Care-Exchange reserves the right to suspend or terminate that
          privilege for any reason at any time, in its sole discretion.
        </p>
        <p>
          <b>5.4 License to Use by Users who are Employers and/or Care Providers.</b>
          Care-Exchange hereby grants you a limited, terminable, non-exclusive
          right to access and use the Sites only for your internal business use
          seeking candidates for employment. This authorizes you to view and
          download a single copy of the material on the Sites solely for your
          personal use directly related to searching for and recruiting clients
          and/or job prospects. Care-Exchange also grants you a limited,
          terminable, non-exclusive license to use the Care-Exchange Materials
          and Services for your internal use only. You may not sell, transfer or
          assign any of the Services or your rights to any of the Services
          provided by Care-Exchange to any third party without the express
          written authorization of Care-Exchange. You agree that you are solely
          responsible for the content of any Document you post to a Site and any
          consequences arising from such posting. Care-Exchange reserves the
          right to suspend or terminate your access and use at any time if
          Care-Exchange determines that you are in breach of these Terms and
          Conditions.
        </p>
        <p>
          <b>5.5 Employer Materials.</b> Employer represents, warrants and covenants
          that any Employer Materials provided by Employer for use in connection
          with the Services will not violate any laws or regulations or
          third-party proprietary rights, including, without limitation,
          copyright, trademark, obscenity, rights of publicity or privacy, and
          defamation laws. Employer hereby grants Care-Exchange a non-exclusive,
          worldwide, royalty-free license to use the Employer Materials and to
          hyperlink to Employer's website in connection with the Services.
        </p>
        <p>
          <b>5.6 Use of Aggregate Data.</b> You understand and agree that Care-Exchange
          owns and has the right to collect, extract, compile, synthesize, and
          analyze Aggregate Data. Care-Exchange may use such Aggregate Data for
          any lawful business purpose without a duty of accounting to you,
          provided that the data and information is used only in an aggregated
          and anonymized form so that it cannot be identifiable as relating to
          you, your Company or to any other Job Seekers. "Aggregate Data"means
          de-identified aggregated data or information regarding Job Seekers'
          educational or career history (including, by way of example and not
          limitation, aggregate data relating to Job Seekers' occupation,
          location, salary, education and experience).
        </p>
        <p>
          <b>5.7 Other Specific Rules Regarding Site Usage.</b> You represent, warrant
          and agree that you (a) are at least 13 years of age or older, and if
          under the age of 18 or the age of majority as that is defined in your
          jurisdiction, you will only use the Sites and Services under the
          supervision of a parent, legal guardian, or other responsible adult;
          and (b) will not use (or plan, encourage or help others to use) the
          Sites for any purpose or in any manner that is prohibited by these
          Terms and Conditions or by applicable law. It is your responsibility
          to ensure that your use of the Sites complies with these Terms and
          Conditions and all applicable laws.
        </p>
        <p>
          <b>5.8 User Submissions.</b> Care-Exchange welcomes your comments regarding
          the Services and the Sites and appreciates hearing from you. Please
          note, however, that Care-Exchange does not accept or consider creative
          ideas, suggestions, inventions or materials other than those which it
          has specifically requested. If you submit feedback on the Services,
          please be specific in your comments and do not submit creative ideas,
          inventions, suggestions, or materials. If, despite this notice, you
          send Care-Exchange creative suggestions, ideas, drawings, concepts,
          inventions, or other information (a "User Submission"), you understand
          and agree that the User Submission shall become the property of
          Care-Exchange. User Submission and any elements contained in User
          Submissions, shall not be subject to any obligation of confidentiality
          on Care-Exchange's part, and Care-Exchange will not be liable for any
          use or disclosure of any User Submission. Care-Exchange shall
          exclusively own all now known or later discovered rights to the User
          Submission and shall be entitled to unrestricted use of the User
          Submission for any purpose whatsoever, commercial or otherwise,
          without compensation to you or any other person.
        </p>
        <p></p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          6. Third Party Providers
        </h4>
        <p>
          You acknowledge and agree that Care-Exchange may provide the Services
          using third party providers, including subcontractors and consultants
          (the "Third Party Providers"). You agree that, as between
          Care-Exchange and its Third Party Providers, Care-Exchange will have
          sole responsibility for handling all billing and contract
          negotiations.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          7. Disclaimers and Limitations on Care-Exchange's Liability
        </h4>
        <p>
          <b>7.1 Allocation of Responsibility</b> Care-Exchange assumes no
          responsibility for Documents posted by Users and no responsibility for
          the activities, omissions or other conduct of Users. Care-Exchange
          acts as a portal for the online distribution and publication of User
          submitted information and has no obligation to screen communications
          or information in advance and is not responsible for verifying or
          screening or monitoring Documents posted by Users and/or Employers. If
          notified by a User of a Document which allegedly does not conform to
          these Terms and Conditions, Care-Exchange may investigate the
          allegation and determine in good faith and in its sole discretion
          whether to remove or request the removal of such Document.
          Care-Exchange has no liability or responsibility to Users for
          performance or nonperformance of such activities or Services.
          Care-Exchange may take any action with respect to User submitted
          information that it deems necessary or appropriate, in its sole
          discretion.
        </p>
        <p>
          <b>7.2 No endorsements by Care-Exchange.</b> Nothing on the Sites shall be
          considered an endorsement, representation or warranty with respect to
          any User or third party, whether in regards to its web site, products,
          services, hiring, experience, employment or recruiting practices, or
          otherwise.
        </p>
        <p><b>7.3 WARRANTY DISCLAIMERS</b></p>
        <ol type="a">
          <li>
            THE SITES ARE PROVIDED ON AN 'AS IS' BASIS WITHOUT ANY WARRANTIES OF
            ANY KIND, EXPRESS OR IMPLIED. CARE-EXCHANGE, TO THE FULLEST EXTENT
            PERMITTED BY LAW, DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT
            LIMITED TO, THE WARRANTIES OF MERCHANTABILITY, TITLE,
            NON-INFRINGEMENT OF THIRD PARTIES' RIGHTS, AND FITNESS FOR A
            PARTICULAR PURPOSE. CARE-EXCHANGE MAKES NO WARRANTIES ABOUT THE
            ACCURACY, RELIABILITY, COMPLETENESS, OR TIMELINESS OF THE SITES.
          </li>
          <li>WITHOUT LIMITATION ON THE FOREGOING:</li>
          <ol type="i">
            <li>
              CARE-EXCHANGE DOES NOT WARRANT THAT THE SITES WILL OPERATE
              ERROR-FREE OR THAT THE SITES AND THEIR SERVERS ARE FREE OF
              COMPUTER VIRUSES OR OTHER HARMFUL MECHANISMS. IF YOUR USE OF THE
              SITES RESULTS DIRECTLY OR INDIRECTLY IN THE NEED FOR SERVICING OR
              REPLACING EQUIPMENT OR DATA, CARE-EXCHANGE IS NOT RESPONSIBLE FOR
              THOSE COSTS.
            </li>
            <li>
              Care-Exchange makes no representations or guarantees regarding the
              truthfulness, accuracy, LEGALITY, completeness, timeliness or
              reliability of any Documents posted by Users, or of any other form
              of communication engaged in by Users. Documents may contain
              inaccuracies or typographical errors. You agree that any reliance
              on Documents posted by Users, or on any other form of
              communication with Users, will be at your own risk.
            </li>
            <li>
              Care-Exchange makes no representations or guarantees regarding the
              Content of the Sites, including, but not limited to, broken links,
              inaccuracies or typographical errors.
            </li>
            <li>
              CARE-EXCHANGE MAKES NO REPRESENTATIONS OR GUARANTEES REGARDING THE
              EFFECTIVENESS OF THE SERVICES OR TIMELINESS OF THE SERVICES IN
              MEETING YOUR CARE OR EMPLOYMENT OBJECTIVES. CARE-EXCHANGE DOES NOT
              GUARANTEE THAT THE SERVICES WILL RESULT IN CLIENTS OR CARE SEEKERS
              HIRING YOU FOR YOUR SERVICE, JOB CANDIDATES BEING HIRED, POSITIONS
              BEING FILLED OR EMPLOYEES BEING RETAINED, AND IS NOT RESPONSIBLE
              OR LIABLE FOR ANY BUSINESS, EMPLOYMENT, HIRING AND/OR SALARY
              DECISIONS, FOR WHATEVER REASON MADE, MADE BY YOU.
            </li>
          </ol>
        </ol>
        <p>
          <b>7.4 DAMAGE LIMITATIONS, ALLOCATIONS OF LIABILITY AND EQUITABLE RELIEF</b>
        </p>
        <ol type="a">
          <li>
            YOU ASSUME ALL RESPONSIBILITY AND RISK FOR YOUR USE OF THE SITES,
            THE INTERNET GENERALLY, AND THE DOCUMENTS OR EMPLOYER MATERIALS THAT
            YOU POST, PROVIDE OR ACCESS AND FOR YOUR CONDUCT ON AND OFF THE
            SITES.
          </li>
          <li>
            IN NO EVENT SHALL CARE-EXCHANGE (OR ANY OF ITS OFFICERS, DIRECTORS,
            SHAREHOLDERS, EMPLOYEES, SUBSIDIARIES, AFFILIATES, AGENTS OR
            ADVERTISERS), BE LIABLE FOR ANY NON-DIRECT DAMAGES WHATSOEVER
            (INCLUDING, WITHOUT LIMITATION, INCIDENTAL AND CONSEQUENTIAL
            DAMAGES, LOST PROFITS, OR DAMAGES RESULTING FROM LOST DATA, LOST
            EMPLOYMENT OPPORTUNITY, OR BUSINESS INTERRUPTION) RESULTING FROM OR
            ARISING UNDER OR IN CONNECTION WITH SERVICES OR THE USE OR ACCESS
            TO, OR THE INABILITY TO USE OR ACCESS, THE SITES AND/OR ANY
            DOCUMENT, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER
            LEGAL THEORY, AND WHETHER OR NOT CARE-EXCHANGE IS ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES.
          </li>
          <li>
            BECAUSE SOME STATES OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR
            LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE
            LIMITATIONS SET FORTH IN THE PRECEDING PARAGRAPH MAY NOT APPLY TO
            YOU. IF ANY ARE HELD INAPPLICABLE OR UNENFORCEABLE FOR ANY REASON,
            THEN CARE-EXCHANGE'S MAXIMUM LIABILITY TO YOU FOR ANY NON-DIRECT
            TYPE OF DAMAGES SHALL BE LIMITED TO U.S. $200.00 IN THE AGGREGATE.
          </li>
          <li>
            IN NO EVENT SHALL CARE-EXCHANGE (OR ANY OF ITS OFFICERS, DIRECTORS,
            SHAREHOLDERS, EMPLOYEES, SUBSIDIARIES, AFFILIATES, AGENTS OR
            ADVERTISERS), BE LIABLE FOR ANY DIRECT DAMAGES IN EXCESS IN THE
            AGGREGATE OF US$200.00 (OR, IF YOU ARE AN EMPLOYER WITH A SERVICES
            AGREEMENT WITH CARE-EXCHANGE, THE AMOUNTS ACTUALLY PAID BY YOU TO
            CARE-EXCHANGE UNDER THIS AGREEMENT IF GREATER THAN US$200.00).
          </li>
          <li>
            Due to the nature of this Agreement, in addition to money damages,
            you agree that Care-Exchange will be entitled to equitable relief
            upon a breach of this agreement by you.
          </li>
        </ol>
        <p>
          <b>7.5 User Authentication.</b> Because User authentication on the Internet
          is difficult, Care-Exchange cannot and does not confirm that each User
          is who they claim to be. Because Care-Exchange does not and cannot be
          involved in User-to-User dealings or control the behavior of
          participants on the Sites, in the event that you have a dispute with
          one or more Users, you release Care-Exchange from claims, demands and
          damages (actual and consequential and direct and indirect) of every
          kind and nature, known and unknown, suspected and unsuspected,
          disclosed and undisclosed, arising out of or in any way connected with
          such disputes.
        </p>
        <p>
          <b>7.6 California Residents.</b> If you are a California resident, you waive
          California Civil Code Section 1542, which says: "A general release
          does not extend to claims which the creditor does not know or suspect
          to exist in his or her favor at the time of executing the release,
          which if known by him or her must have materially affected his or her
          settlement with the debtor."
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          8. Data Protection
        </h4>
        <p>If you are an Employer, this Section 7 applies</p>
        <p>
          <b>8.1</b> To the extent that the provision of the Services under this
          Agreement involves the processing of Employer Personal Data by
          Care-Exchange as a processor on behalf of Employer as a data
          controller under GDPR, Care-Exchange's Data Protection Addendum is
          incorporated into, and hereby forms a part of, this Agreement.
        </p>
        <p>
          <b>8.2</b> To the extent that the provision of the Services under this
          Agreement involves personal data subject to GDPR other than Employer
          Personal Data, such data is provided by Care-Exchange as a data
          controller to Employer as a data controller for the Intended Purpose
          and:
        </p>
        <ol type="a">
          <li>
            Care-Exchange warrants that it has an adequate legal basis under
            GDPR for sharing that data with Employer for the uses permitted by
            Section 4.4; and
          </li>
          <li>
            Employer will comply with GDPR and any other applicable data
            protection laws with respect to such data, including:
          </li>
          <ol type="i">
            <li>
              Processing such data fairly and lawfully and only for the Intended
              Purpose
            </li>
            <li>
              Processing such data only for as long as is necessary for the
              Intended Purpose and deleting such data once the Intended Purpose
              has been fulfilled
            </li>
            <li>
              Having in place appropriate technical and organizational measures
              to protect such data against accidental or unlawful destruction or
              accidental loss, alternation, unauthorized disclosure or access,
              and which provide a level of security appropriate to the risk
              represented by the processing and the nature of the data
            </li>
            <li>
              Having in place procedures so that any third party it authorizes
              to have access to such data, including processors, will respect
              and maintain the confidentiality and security of the data
            </li>
            <li>
              not disclosing or transferring such data to a third party located
              outside of the European Economic Area or Switzerland unless it
              does so in compliance with all applicable data protection laws
            </li>
            <li>
              complying with data subject requests received by it for access to,
              or correction, amendment, blocking or deletion of, such data made
              pursuant to applicable data protection laws.
            </li>
          </ol>
        </ol>
        <p>
          <b>8.3</b> For the purposes of this Section 7, "GDPR" means the Regulation
          (EU) 2016/679 of the European Parliament and of the Council of the 27
          April 2016 on the protection of natural persons with regards to the
          processing of personal data and on the free movement of such data as
          applicable as of 25 May 2018 as may be amended from time to time,
          together with all laws and regulations implementing the same in any
          European Member State and "Employer Personal Data" means personal data
          concerning Job Seekers that has been uploaded by Employer or by a Job
          Seeker directly to the Services operated by Care-Exchange solely on
          behalf of the Employer and subject to GDPR with respect to the
          processing of such personal data.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          9. Links to Other Sites
        </h4>
        <p>
          Care-Exchange contains links to third party web sites. These links are
          provided solely as a convenience to you and not as an endorsement by
          Care-Exchange of the contents on such third-party web sites.
          Care-Exchange is not responsible for the content of linked third-party
          sites and does not make any representations regarding the content or
          accuracy of materials on such third-party web sites. If you decide to
          access linked third-party web sites, you do so at your own risk.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          10. Amendments to this Agreement and Changes to Sites
        </h4>
        <p>
          Care-Exchange may revise these Terms and Conditions at any time by
          updating this page. Changes will be binding on you on the date they
          are posted on the Sites (or as otherwise stated in the any notice of
          such changes). Any use of a Site will be considered acceptance by you
          of the then-current Terms and Conditions (including any exhibits
          thereto) contained on such Site. If at any time you find the Terms and
          Conditions unacceptable, you may not use the applicable Site any
          longer. Any new or different terms supplied by you are specifically
          rejected by Care-Exchange unless Care-Exchange agrees to them in a
          signed writing specifically including those new or different terms.
          Care-Exchange may change the Sites at any time.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>11. Indemnity</h4>
        <p>
          You agree to defend, indemnify, and hold harmless Care-Exchange (and
          its subsidiaries, affiliates, officers, directors, employees and
          agents) from and against any third party claims, actions or demands
          (including, without limitation, costs, damages and reasonable legal
          and accounting fees) alleging or resulting from or in connection with
          your use of the Sites, any Document posted by you, your use of the
          Services or your breach of this Agreement. Care-Exchange shall use
          reasonable efforts to provide you prompt notice of any such claim,
          suit, or proceeding and may assist you, at your expense, in defending
          any such claim, suit or proceeding.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          12. User Information and Privacy Policy
        </h4>
        <p>
          <b>12.1</b> When you register on any of the Care-Exchange Sites or in
          connection with the Services, you will be asked to create an account
          and provide Care-Exchange with certain information, including but not
          limited to, a valid email address ("User Information"). You
          acknowledge and agree that you have no ownership rights in your
          account.
        </p>
        <p>
          <b>12.2</b> All User Information will be used in accordance with the terms of
          Care-Exchange's Privacy Policy. Please note, as set forth in the
          Privacy Policy, that Care-Exchange may collect certain User
          Information and may contact Users periodically in accordance with the
          terms of the Privacy Policy. In addition, Care-Exchange reserves the
          right to comply, in its sole discretion, with legal requirements,
          requests from law enforcement agencies or requests from government
          entities, even to the extent that such compliance may require
          disclosure of certain User Information. In addition, third parties may
          retain cached copies of User Information.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          13. Questions and Notices
        </h4>
        <p>
          Questions concerning the use of the Sites should be directed to
          Contact Us. Notices to Care-Exchange should be sent to the address
          listed on the Sites. We will send notice to you at the address
          submitted by you or to such other address as Care-Exchange reasonably
          determines is an appropriate address for you.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>14. General</h4>
        <p>
          Care-Exchange contact information is listed on the Sites.
          Care-Exchange makes no claims that the Content is appropriate or may
          be downloaded outside of the United States. Access to the Content may
          not be legal by certain persons or in certain countries, and such
          persons have no right to access or use the Sites. If you access
          Care-Exchange from outside of the United States, you do so at your own
          risk and are responsible for compliance with the laws of your
          jurisdiction. This Agreement and your Subscription Plan Purchase
          Agreement, if you have one, are governed by the internal substantive
          laws of the State of California, without respect to its conflict of
          laws principles. Jurisdiction for any claims arising under this
          Agreement or your Subscription Plan Purchase Agreement shall lie
          exclusively with the state or federal courts in the State of
          California. The sole relationship between you and Care-Exchange is
          that of independent contractors. If any provision of this Agreement is
          found to be invalid by any court having competent jurisdiction, the
          invalidity of all or part of a provision shall not affect the validity
          of the remaining parts and provisions of this Agreement, which shall
          remain in full force and effect. All provisions of this Agreement
          shall survive termination except those granting access or use to the
          Sites, and you shall cease all your use and access thereof
          immediately. You may not assign or transfer your obligations under
          this Agreement. No waiver of any term of this Agreement shall be
          deemed a further or continuing waiver of such term or any other term.
          Except as expressly provided by Care-Exchange in a particular "Legal
          Notice," or material on particular web pages of the Sites, this
          Agreement and your Subscription Plan Purchase Agreement where
          applicable, constitute the entire agreement between you and
          Care-Exchange.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          15. Rules regarding Posting, Conduct and Security.
        </h4>
        <p>
          The following rules apply to your use of the Sites and/or the
          Services. The list of rules is for illustration only and is not a
          complete list of all posting, conduct and security rules.
        </p>
        <p><b>15.1 Posting Rules:</b></p>
        <ol type="a">
          <li>You may not post any Document to a Site that contains:</li>
          <ol type="i">
            <li>
              URLs or links to web sites other than to recruitment related pages
              on your company web site (to advertise your company or web site);
            </li>
            <li>
              copyrighted material (unless you own the copyright or have the
              owner's permission to post the copyrighted material);
            </li>
            <li>
              trade secrets (unless you own them or have the owner's permission
              to post them)
            </li>
            <li>
              material that infringes on or misappropriates any other
              intellectual property rights, or violates the privacy or publicity
              rights of others;
            </li>
            <li>
              irrelevant keywords or white text keywords (including any words
              embedded in the Document and hidden from the User)
            </li>
            <li>
              anything that is discriminatory, sexually explicit, obscene,
              libelous, defamatory, threatening, harassing, abusive, or hateful;
              or
            </li>
            <li>
              anything that is embarrassing or offensive to another person or
              entity.
            </li>
          </ol>
          <li>You may not use a Document(s) to:</li>
          <ol type="i">
            <li>impersonate another person, living or dead;</li>
            <li>
              post false, inaccurate or misleading information, opinions or
              notices (commercial or otherwise) or chain letters;
            </li>
            <li>
              post advertisements, or solicitations of business (including, but
              not limited to, email processors, any pyramid scheme or "club
              membership"); provided, however that Care-Exchange may allow
              posting of certain training and business opportunities (see
              14.1(e) below).
            </li>
          </ol>
          <li>
            Your Document(s) must contain sufficient detail to convey clearly to
            the User the nature and requirements of the job opportunity, or, in
            the case of Users seeking employment, your qualifications as a
            candidate for employment. Documents that encourage the User to
            "email for more details" are not permitted.
          </li>
          <li>
            Job postings must describe individual openings for traditional W-2
            or 1099 employees. You may not advertise multiple job openings in a
            single posting.
          </li>
          <li>
            In limited circumstances, at Care-Exchange's sole discretion,
            Care-Exchange allows non-traditional job postings such as
            education/training, business opportunities, franchise, and
            multi-level marketing opportunities to be posted on the Sites. These
            non-traditional job postings may require an investment of time
            and/or money by the User seeking the position. Care-Exchange
            reserves the right, in its sole discretion, to move, modify, or
            remove entirely a non-traditional job posting if Care-Exchange deems
            such job posting to conflict with the best interests of its Users or
            detract from the User experience.
          </li>
          <li>
            Resume postings must contain the accurate resume of a living
            individual seeking employment on a full-time, part-time, or
            contractual basis on his or her own behalf.
          </li>
          <li>
            Care-Exchange is under no obligation to monitor the Documents posted
            on the Sites, but it may monitor Documents at random. Documents
            found to violate the above Posting Rules may be removed at
            Care-Exchange's sole discretion.
          </li>
        </ol>
        <p><b>15.2 Conduct Rules:</b></p>
        <ol type="a">
          <li>
            You may not respond to postings by other Users in any manner or for
            any purpose other than that which is expected (i.e., to apply for
            the job or to initiate further discussion with the candidate).
            Communications soliciting the Employer's business are prohibited.
          </li>
          <li>You may not send unsolicited commercial email to Users.</li>
          <li>
            Protect your password. Your Care-Exchange account and any related
            Services accessed through such account are to be accessed and used
            solely by you. Upon your successful registration for a Care-Exchange
            account, you will be provided with a unique password that will
            permit you to access the account. You may not provide your password
            or otherwise permit access to your Care-Exchange account to any
            third party. You are responsible for maintaining the confidentiality
            of your information and password. You agree to protect and keep your
            password confidential, to change your password on a regular basis,
            and to maintain appropriate and regularly updated malware scanning
            and cleaning tools on your network and individual computer(s).You
            are responsible for all uses of your account, whether or not
            authorized by you. If others use your password to post inappropriate
            material on the Sites, you risk losing your access to the Sites. You
            agree to notify Care-Exchange immediately of any unauthorized use of
            your account or password.
          </li>
          <li>Report inappropriate postings or conduct to Contact Us.</li>
          <li>
            You may not delete or revise any material posted by any other person
            or entity.
          </li>
          <li>
            If at any time Care-Exchange comes to the understanding that you:
            (i) misled Care-Exchange regarding your business practices and/or
            services, or (ii) purchased services that do not represent your
            precise business, Care-Exchange reserves the right to terminate your
            Agreement.
          </li>
        </ol>
        <p><b>15.3 Security Rules:</b></p>
        <ol type="a">
          <li>
            Users are prohibited from violating or attempting to violate the
            security of the Sites, including, without limitation:
          </li>
          <ol type="i">
            <li>
              accessing data not intended for such User or logging into a server
              or account which the User is not authorized to access;
            </li>
            <li>
              attempting to probe, scan or test the vulnerability of a system or
              network or to breach security or authentication measures without
              proper authorization;
            </li>
            <li>
              attempting to interfere with service to any User, host or network,
              including, without limitation, via means of submitting a virus to
              the Sites, overloading, "flooding", "mail bombing" or "crashing";
            </li>
            <li>
              sending unsolicited e-mail, including promotions and/or
              advertising of products or services;
            </li>
            <li>
              forging any TCP/IP packet header or any part of the header
              information in any e-mail or newsgroup posting.
            </li>
          </ol>
          <li>
            Violation of these Security Rules may result in civil or criminal
            liability. Care-Exchange will investigate occurrences which may
            involve such violations and may involve, and cooperate with, law
            enforcement authorities in prosecuting Users who are involved in
            such violations.
          </li>
        </ol>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          16. Copyright Notices/Complaints
        </h4>
        <p>
          It is Care-Exchange’s policy to respond to notices of alleged
          copyright infringement with the Digital Millennium Copyright Act
          (“DMCA”). If you believe any materials accessible on or from our Site
          infringe your copyright, you may request removal of those materials
          (or access thereto) from the Site by contacting Care-Exchange’s
          copyright agent (identified below) and providing the following
          information:
        </p>
        <ol type="1">
          <li>
            Identification of the copyrighted work that you believe to be
            infringed. Please describe the work, and where possible include a
            copy or the location (e.g., URL) of an authorized version of the
            work.
          </li>
          <li>
            Identification of the material that you believe to be infringing and
            its location. Please describe the material and provide us with its
            URL or any other pertinent information that will allow us to locate
            the material.
          </li>
          <li>
            Your name, address, telephone number and (if available) e-mail
            address.
          </li>
          <li>
            A statement that you have a good faith belief that the complained of
            use of the materials is not authorized by the copyright owner, its
            agent, or the law.
          </li>
          <li>
            A statement that the information that you have supplied is accurate,
            and indicating that “under penalty of perjury,” you are the
            copyright owner or are authorized to act on the copyright owner’s
            behalf.
          </li>
          <li>
            A signature or the electronic equivalent from the copyright holder
            or authorized representative.
          </li>
        </ol>
        <p>
          Care-Exchange’s agent for copyright issues relating to this Site is as
          follows:
        </p>
        <p>Copyright Manager</p>
        <p>Care Exchange, Inc.</p>
        <p>Attn: Legal Department</p>
        <p>10970 Arrow Route, Suite 206</p>
        <p>Rancho Cucamonga, CA 91730</p>
        <p>martin@care-exchange.com </p>
        <p>Phone: 909-870-9016</p>
        <p>
          In an effort to protect the rights of copyright owners,
          Care-Exchange.com maintains a policy for the termination, in
          appropriate circumstances, of Members and other users of this Site who
          are repeat infringers.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          17. Agreement to Arbitrate
        </h4>
        <p><b>17.1 Agreement to Arbitrate</b></p>
        <p>
          This Section 16 is referred to in these Terms as the “Arbitration
          Agreement”. Unless you opt-out in accordance with the opt-out
          procedures set forth in Section 16.8 below, you agree that all claims
          relating to or arising out of these Terms & Conditions or the breach
          thereof other than those expressly set out in Section 16.4, whether
          sounding in contract, tort, or otherwise that have arisen or may arise
          between you and Care-Exchange or a Care-Exchange Affiliate, whether
          relating to these Terms (including any alleged breach thereof), the
          Services, the Site, or otherwise, shall be resolved exclusively
          through final and binding arbitration, rather than a court, in
          accordance with the terms of this Arbitration Agreement. This includes
          claims that arose, were asserted, or involve facts occurring before
          the existence of this Arbitration Agreement or any prior agreement as
          well as claims that may arise after the termination of this
          Arbitration Agreement, in accordance with the notice and opt-out
          provisions set forth herein. Your rights will be determined by a
          neutral arbitrator, not a judge or jury. The Federal Arbitration Act
          governs the interpretation and enforcement of this Arbitration
          Agreement.
        </p>
        <p>
          <b>17.2 Prohibition of Class and Representative Actions and
          Non-Individualized Relief</b>
        </p>
        <p>
          YOU AND CARE-EXCHANGE.COM AGREE THAT EACH OF US MAY BRING CLAIMS
          AGAINST THE OTHER ONLY ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF
          OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE ARBITRATION,
          ACTION OR PROCEEDING. EXCEPT FOR AS SET FORTH IN SECTION 16.7, UNLESS
          BOTH YOU AND CARE-EXCHANGE.COM EXPRESSLY AGREE OTHERWISE, THE
          ARBITRATOR MAY NOT CONSOLIDATE OR JOIN MORE THAN ONE PERSON’S OR
          PARTY’S CLAIMS AGAINST CARE-EXCHANGE.COM AND MAY NOT OTHERWISE PRESIDE
          OVER ANY FORM OF A CONSOLIDATED, REPRESENTATIVE, OR CLASS PROCEEDING.
          ALSO, THE ARBITRATOR MAY AWARD RELIEF (INCLUDING MONETARY, INJUNCTIVE,
          AND DECLARATORY RELIEF) ONLY IN FAVOR OF THE INDIVIDUAL PARTY SEEKING
          RELIEF AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF NECESSITATED
          BY THAT PARTY’S INDIVIDUAL CLAIM(S). ANY RELIEF AWARDED CANNOT AFFECT
          OTHER CARE-EXCHANGE.COM USERS. If any court or arbitrator determines
          that the class action waiver set forth in this paragraph is void or
          unenforceable for any reason or that an arbitration can proceed on a
          class basis, then the arbitration provision set forth above shall be
          deemed null and void in its entirety and the parties shall be deemed
          to have not agreed to arbitrate disputes.
        </p>
        <p><b>17.3 Pre-Arbitration Dispute Resolution</b></p>
        <p>
          Care-Exchange.com is always interested in resolving Disputes amicably
          and efficiently. Accordingly, both parties acknowledge and agree that
          before they commence arbitration, they will first make a good faith
          effort to resolve such Dispute informally. Such informal resolution
          requires first sending a written description of the Dispute to the
          other party. For any Dispute you initiate, you agree to send the
          written description of the Dispute along with the email address
          associated with your account, if applicable, to the following address:
          Care-Exchange, Inc., Attn: Legal Department, 10970 Arrow Route, Suite
          206, Rancho Cucamonga, CA 91730. The written description must be on an
          individual basis and provide, at minimum, the following information:
          your name; a description of the nature or basis of the Dispute; the
          specific relief sought; and proof of your relationship with
          Care-Exchange.com. If the Dispute is not resolved within sixty (60)
          days after receipt of the written description of the notice, you and
          Care-Exchange.com agree to follow the resolution procedures for any
          Dispute described in this Section 16.
        </p>
        <p>
          The aforementioned informal dispute resolution process is a
          prerequisite and condition precedent to commencing any formal dispute
          resolution proceeding (“Claim”). The parties agree that any relevant
          limitations period and filing fees or other deadlines will be tolled
          while the parties engage in this informal dispute resolution process.
        </p>
        <p><b>17.4 Arbitration Procedures</b></p>
        <p>
          If we cannot resolve a Claim informally, any Claim either of us
          asserts will be resolved only by binding arbitration (except as
          otherwise specifically provided herein) and not in courts of general
          jurisdiction. Arbitration will be conducted by a neutral arbitrator in
          accordance with the rules of National Arbitration and Mediation
          (“NAM”), including, as applicable, NAM Comprehensive Dispute
          Resolution Rules and Procedures, Fees For Disputes When One of the
          Parties is a Consumer and the Mass Filing Dispute Resolution Rules and
          Procedures in effect at the time any demand for arbitration is filed
          with NAM, excluding any rules or procedures governing or permitting
          class or representative actions, as modified by this Arbitration
          Agreement. For information on NAM, please visit its website,
          https://www.namadr.com/. Information about NAM’s Rules and fees can be
          found at https://www.namadr.com/resources/rules-fees-forms/. If there
          is any inconsistency between the NAM Rules and this Arbitration
          Agreement, the terms of this Arbitration Agreement will control unless
          the arbitrator determines that the application of the inconsistent
          Arbitration Agreement terms would not result in a fundamentally fair
          arbitration. The arbitrator must also follow the provisions of these
          Terms & Conditions as a court would, including without limitation, the
          limitation of liability provisions in Section 7. Although arbitration
          proceedings are usually simpler and more streamlined than trials and
          other judicial proceedings, the arbitrator can award the same damages
          and relief on an individual basis that a court can award to an
          individual under the Terms and applicable law. Decisions by the
          arbitrator are enforceable in court. If you are a Care-Exchange.com
          registered user, any demand initiating arbitration, whether filed by
          You or Care-Exchange.com, must include the email address you used to
          register with Care-Exchange.com.
        </p>
        <p>
          For all U.S. residents, the arbitration shall be held (i) at a
          location determined under the applicable NAM rules and procedures that
          is reasonably convenient for you and is no more than 100 miles from
          your home or place of business; or (ii) at another location you and we
          agree upon. For non-U.S. residents, the arbitration shall be held in
          Los Angeles, CA (unless otherwise agreed by the parties). If the value
          of the relief sought is $10,000 or less you or Care-Exchange.com may
          elect to have the arbitration conducted by telephone or based solely
          on written submissions, which election shall be binding on you and
          Care-Exchange.com subject to the arbitrator’s discretion to require an
          in-person hearing, if the circumstances warrant. Attendance at any
          in-person hearing may be made by telephone by you and/or
          Care-Exchange.com, unless the arbitrator requires otherwise.
        </p>
        <p>
          The arbitrator, and not any federal, state or local court or agency,
          shall have exclusive authority to resolve all claims relating to or
          arising out of this contract, or the breach thereof, whether sounding
          in contract, tort, or otherwise and all disputes arising out of or
          relating to the interpretation, applicability, enforceability or
          formation of these Terms, including, but not limited to any claim that
          all or any part of these Terms are void or voidable, or whether a
          claim is subject to arbitration. The arbitrator shall be empowered to
          grant whatever relief would be available in a court under law or in
          equity. The arbitrator’s award shall be written, and binding on the
          parties and may be entered as a judgment in any court of competent
          jurisdiction. Subject to the applicable NAM rules and procedures, the
          parties agree that the arbitrator will have the discretion to allow
          the filing of dispositive motions if they are likely to efficiently
          resolve or narrow issues in dispute.
        </p>
        <p>
          The arbitrator will decide the substance of all claims in accordance
          with the laws of the State of Delaware, including recognized
          principles of equity, and will honor all claims of privilege
          recognized by law. Except for decisions in arbitrations that are
          joined together in a single batch as described in Section 16.7, an
          arbitrator shall not be bound by rulings in prior arbitrations
          involving different Care-Exchange.com users, but is bound by rulings
          in prior arbitrations involving the same Care-Exchange.com user to the
          extent required by applicable law.
        </p>
        <p>
          Notwithstanding the parties’ decision to resolve all Claims through
          arbitration, each party retains the right to (i) elect to have any
          Claims resolved in small claims court on an individual basis for
          disputes and actions within the scope of such court’s jurisdiction,
          regardless of what forum the filing party initially chose; (ii) bring
          an action in state or federal court to protect its intellectual
          property rights (“intellectual property rights” in this context means
          patents, copyrights, moral rights, trademarks, and trade secrets and
          other confidential or proprietary information, but not privacy or
          publicity rights);) and (iii) seek a declaratory judgment, injunction,
          or other equitable relief in a court of competent jurisdiction
          regarding whether a party’s claims are time-barred or may be brought
          in small claims court. Seeking such relief shall not waive a party’s
          right to arbitration under this Arbitration Agreement, and any filed
          arbitrations related to any action filed pursuant to this paragraph
          shall automatically be stayed pending the outcome of such action.
        </p>
        <p><b>17.5 Costs of Arbitration</b></p>
        <p>
          If you are able to demonstrate that the costs of arbitration will be
          prohibitive as compared to the costs of litigation, Care-Exchange.com
          will pay as much of any filing and hearing fees in connection with the
          arbitration in excess of $250 that the arbitrator deems necessary to
          prevent the arbitration from being cost-prohibitive regardless of the
          outcome of the arbitration, unless the arbitrator determines that your
          claim(s) were frivolous or asserted in bad faith, in which case
          arbitration fees (including attorneys’ fees) may be imposed upon you
          consistent with the arbitrator’s rules and the standard for sanctions
          set forth in Federal Rule of Civil Procedure 11. You are responsible
          for all other fees, including your own attorneys’ fees, unless the
          arbitration rules and/or applicable law provide otherwise.{" "}
        </p>
        <p>
          The parties agree that NAM has discretion to reduce the amount or
          modify the timing of any administrative or arbitration fees due under
          NAM’s Rules where it deems appropriate (including as specified in
          Section 16.7) provided that such modification does not increase the
          costs to you, and you further agree that you waive any objection to
          such fee modification. The parties also agree that a good-faith
          challenge by either party to the fees imposed by NAM does not
          constitute a default, waiver, or breach of this Arbitration Agreement
          while such challenge remains pending before NAM, the arbitrator,
          and/or a court of competent jurisdiction, and that any and all due
          dates for those fees shall be tolled during the pendency of such
          challenge.
        </p>
        <p><b>17.6 Confidentiality</b></p>
        <p>
          All aspects of the arbitration proceeding, and any ruling, decision or
          award by the arbitrator, will be strictly confidential for the benefit
          of all parties.
        </p>
        <p><b>17.7 Mass Filing Procedures</b></p>
        <p>
          To increase the efficiency of administration and resolution of
          arbitrations, in the event 100 or more similar arbitration demands
          (those asserting the same or substantially similar facts or claims,
          and seeking the same or substantially similar relief) presented by or
          with the assistance or coordination of the same law firm(s) or
          organization(s) are submitted to NAM against Care-Exchange.com within
          reasonably close proximity (“Mass Filing”), the parties agree (i) to
          administer the Mass Filing in batches of 100 demands per batch (to the
          extent there are fewer than 100 arbitration demands left over after
          the batching described above, a final batch will consist of the
          remaining demands) with only one batch filed, processed, and
          adjudicated at a time; (ii) to designate one arbitrator for each
          batch; (iii) to accept applicable fees, including any related fee
          reduction determined by NAM in its discretion; (iv) that no other
          demands for arbitration that are part of the Mass Filing may be filed,
          processed, or adjudicated until the prior batch of 100 is filed,
          processed, and adjudicated; (v) that fees associated with a demand for
          arbitration included in a Mass Filing, including fees owed by
          Care-Exchange.com and the claimants, shall only be due after your
          demand for arbitration is included in a set of batch proceedings and
          that batch is properly designated for filing, processing, and
          adjudication; and (vi) that the staged process of batched proceedings,
          with each set including 100 demands, shall continue until each demand
          (including your demand) is adjudicated or otherwise resolved.
          Arbitrator selection for each batch shall be conducted to the greatest
          extent possible in accordance with the applicable NAM rules and
          procedures for such selection, and the arbitrator will determine the
          location where the proceedings will be conducted.{" "}
        </p>
        <p>
          You agree to cooperate in good faith with Care-Exchange.com and the
          arbitration provider to implement such a “batch approach” or other
          similar approach to provide for an efficient resolution of claims,
          including the payment of combined reduced fees, set by NAM in its
          discretion, for each batch of claims. The parties further agree to
          cooperate with each other and the arbitration provider or arbitrator
          to establish any other processes or procedures that the arbitration
          provider or arbitrator believe will provide for an efficient
          resolution of claims. Any disagreement between the parties as to
          whether this provision applies or as to the process or procedure for
          batching shall be resolved by a procedural arbitrator appointed by
          NAM. This “Batch Arbitration” provision shall in no way be interpreted
          as increasing the number of claims necessary to trigger the
          applicability of NAM’s Mass Filing Supplemental Dispute Resolution
          Rules and Procedures or authorizing class arbitration of any kind.
          Unless Care-Exchange.com otherwise consents in writing,
          Care-Exchange.com does not agree or consent to class arbitration,
          private attorney general arbitration, or arbitration involving joint
          or consolidated claims under any circumstances, except as set forth in
          this Section 16.7. If your demand for arbitration is included in the
          Mass Filing, your claims will remain tolled until your demand for
          arbitration is decided, withdrawn, or is settled. The parties agree
          that this batching provision is integral to the Arbitration Agreement
          insofar as it applies to a Mass Filing. If the batching provision in
          this subpart (vi) is found to be invalid, unenforceable or illegal,
          then the entirety of this Arbitration Agreement shall be null and
          void, and neither you nor Care-Exchange.com shall be entitled to
          arbitrate any claim that is a part of the Mass Filing.
        </p>
        <p>
          The results of the first batch of demands will be given to a NAM
          mediator selected from an initially proposed group of 5 mediators,
          with Care-Exchange.com and the remaining claimants’ counsel being able
          to strike one mediator each and then rank the remaining mediators and
          the highest collectively ranked mediator being selected. The selected
          mediator will try to facilitate a resolution of the remaining demands
          in the Mass Filing. After the results are provided to the mediator,
          Care-Exchange.com, the mediator and the remaining claimants will have
          90 days (the “Mediation Period”) to agree on a resolution or
          substantive methodology for resolving the outstanding demands. If they
          are unable to resolve the outstanding demands during the Mediation
          Period, and cannot agree on a methodology for resolving them through
          further arbitrations, either Care-Exchange.com or any remaining
          claimant may opt out of the arbitration process and have the demand(s)
          proceed in court. Notice of the opt-out will be provided in writing
          within 60 days of the close of the Mediation Period. If neither
          Care-Exchange.com nor the remaining claimants opt out and they cannot
          agree to a methodology for resolving the remaining demands through
          further arbitration, the arbitrations will continue with the batching
          process. Opt out of arbitration under this section shall not be
          construed as opt out of the “Class Action Waiver.” Absent notice of an
          opt-out, the arbitrations will proceed in the order determined by the
          sequential numbers assigned to demands in the Mass Filing.{" "}
        </p>
        <p><b>17.8 Opt-Out Procedure</b></p>
        <p>
          You can choose to reject this Arbitration Agreement by mailing us a
          written opt-out notice (“Opt-Out Notice”) in accordance with the terms
          of this Section. For new Care-Exchange.com users, the Opt-Out Notice
          must be postmarked no later than 30 Days after the date you use our
          Site or Services for the first time. If you are already a current
          Care-Exchange.com user and previously accepted the Care-Exchange.com
          Terms prior to the introduction of this Arbitration Agreement, the
          Opt-Out Notice must be postmarked no later than thirty (30) days from
          April 1, 2025. You must mail the Opt-Out Notice to Care-Exchange,
          Inc., Attn: Legal Department, 10970 Arrow Route, Suite 206, Rancho
          Cucamonga, CA 91730. The Opt-Out Notice must state that you do not
          agree to the Arbitration Agreement and must include your name,
          address, phone number, and the email address(es) used to log in to the
          Care-Exchange.com account(s) to which the opt-out applies. You must
          sign the Opt-Out Notice for it to be effective. This procedure is the
          only way you can opt out of the Arbitration Agreement. If you opt out
          of the Arbitration Agreement, Care-Exchange.com will likewise not be
          bound by these arbitration provisions. If you opt out of the
          Arbitration Agreement, you may exercise your right to a trial by jury
          or judge, as permitted by applicable law, but any prior existing
          agreement to arbitrate disputes under a prior version of the
          Arbitration Agreement will not apply to claims not yet filed. All
          other terms of these Terms will continue to apply.
        </p>
        <p><b>17.9 Future Changes to this Arbitration Agreement</b></p>
        <p>
          Notwithstanding any provision in these Terms to the contrary, you and
          we agree that if we make any material change to this Arbitration
          Agreement in the future, such change shall not be effective until 30
          days from the date of posting, and shall not apply to any claim that
          was filed in a legal proceeding against Care-Exchange.com prior to the
          effective date of the change, but will apply to all claims not yet
          filed regardless of when such claims may have accrued. If
          Care-Exchange.com changes this Arbitration Agreement, any failure to
          opt out within 30 days of such changes will be deemed acceptance of
          those changes.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          18. Governing Law and Jurisdiction
        </h4>
        <p>
          These Terms, and all claims relating to or arising out of this
          contract, or the breach thereof, whether sounding in contract, tort,
          or otherwise, shall be governed by the laws of the State of
          California, including California’s statutes of limitations governing
          your claim, without giving effect to its principles of conflicts of
          law, provided that the Federal Arbitration Act shall govern the
          interpretation and enforcement of Section 16, the Arbitration
          Agreement.
        </p>
        <p>
          Unless you and we agree otherwise, in the event that the Arbitration
          Agreement is found not to apply to you or to a particular claim or
          dispute (except for small-claims court actions), either as a result of
          your decision to opt-out of the Arbitration Agreement or as a result
          of a decision by the arbitrator or a court order, you agree that any
          claim or dispute that has arisen or may arise between you and
          Care-Exchange.com must be resolved exclusively by a state or federal
          court located in the State of California.
        </p>
        <p>
          You and Care-Exchange.com agree to submit to the personal jurisdiction
          of the courts located within the State of California for the purpose
          of litigating all such claims or disputes.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          19. Consent to Electronic Communication
        </h4>
        <p>
          By using the Site or Services of Care-Exchange.com, you agree to allow
          Care-Exchange.com to communicate with you electronically, and you
          consent to electronic delivery of notices, documents, or products
          (including, without limitation, reports or copies of Documents and
          Preliminary Membership Screens) from Care-Exchange.com via the
          Care-Exchange.com Site, Services, mobile application, online messaging
          platform, or e-mail. You also agree to check your Care-Exchange.com
          account, alerts, and messages, and the e-mail account reflected on
          your Care-Exchange.com (which you are also required to keep updated)
          on a reasonably regular basis to stay apprised of important notices
          and information about your account.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          20. Miscellaneous
        </h4>
        <p>
          Nothing in this Agreement shall be construed as making either party
          the partner, joint venturer, agent, legal representative, employer,
          contractor or employee of the other. Neither party shall have, or hold
          itself out to any third party as having any authority to make any
          statements, representations or commitments of any kind, or to take any
          action, that shall be binding on the other, except as provided for
          herein or authorized in writing by the party to be bound. The
          invalidity, illegality or unenforceability of any term or provision of
          these Terms & Conditions shall in no way effect the validity, legality
          or enforceability of any other term or provision of these Terms. Each
          Affiliate (as defined in Section 1.2) is expressly made a third party
          beneficiary of this Agreement and may enforce this Agreement directly
          against you. This Agreement will be binding on and will inure to the
          benefit of the legal representatives, successors and assigns of the
          parties hereto.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          21. Severability
        </h4>
        <p>
          If a court decides that any term or provision of these Terms other
          than Section 16 is invalid or unenforceable, the parties agree to
          replace such term or provision with a term or provision that is valid
          and enforceable and that comes closest to expressing the intention of
          the invalid or unenforceable term or provision, and these Terms shall
          be enforceable as so modified.
        </p>

        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>
          22. Contact Information
        </h4>
        <p>
          If you have any questions or need further information as to the Site
          or Services provided by Care-Exchange.com, or need to notify
          Care-Exchange.com as to any matters relating to the Site or Services,
          please contact Care-Exchange.com at:
        </p>
        <p>Care-Exchange, Inc.</p>
        <p>10970 Arrow Route, Suite 206</p>
        <p>Rancho Cucamonga, CA 91730</p>
        <p>support@care-exchange.com </p>
        <p>Phone: 909-870-9016</p>
      </div>
    </div>
  );
};

export default Term;
